import { Box, Button, CircularProgress, Typography } from '@mui/material';
import { useContext, useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
// Our Components
import RedemptionComponent from './RedemptionComponent';
import { AuthContext } from 'context/auth-context';
// Services
import { totalRewards } from 'lib/api/rewards';
// Helpers
import { btcFormat, numberFormat, satoshiFormatter } from 'helpers/i18n';
import { LAYOUT_ROUTES } from 'routes';
// Assets
import Trophy from 'assets/overviewSection/trophy.png';
import RewardBackground from 'assets/overviewSection/reward-background.png';

const styles = {
    firstContainer: {
        background: 'linear-gradient(109.85deg, rgba(27, 171, 226, 0.2) 9.83%, rgba(27, 171, 226, 0.05) 131.53%)',
        backgroundColor: '#FFF',
        position: 'relative',
        height: 1,
        overflow: 'hidden',
        paddingTop: '24px',
        paddingLeft: '40px',
        paddingRight: '40px',
        paddingBottom: '16px'
    },
    paystandLogoBroken: {
        position: 'absolute',
        width: 'auto',
        right: 0,
        top: '-25%',
        height: '150%'
    },
    earnedLabel: {
        color: '#182C55',
        fontStyle: 'normal',
        fontWeight: '500',
        fontSize: '14px',
        lineHeight: '22px'
    },
    pointsLabel: {
        color: '#182C55',
        fontStyle: 'normal',
        fontWeight: '700',
        fontSize: '35px',
        lineHeight: '43px',
        marginTop: '4px'
    },
    exchangeLabel: {
        color: '#182C55',
        fontStyle: 'normal',
        fontWeight: '700',
        fontSize: '14px',
        lineHeight: '22px',
        marginTop: '8px'
    },
    redeemButton: {
        backgroundColor: '#1BABE2',
        borderRadius: '4px',
        color: '#FFF',
        fontWeight: '600',
        fontSize: '13px',
        width: 1,
        marginTop: '20px',
        '&:hover': {
            backgroundColor: 'rgba(27, 171, 226, 0.75)'
        }
    },
    rewardHistory: {
        position: 'relative',
        fontStyle: 'normal',
        fontWeight: 'bold !important',
        fontSize: '12px',
        lineHeight: '16px',
        textTransform: 'uppercase',
        color: '#1BABE2',
        cursor: 'pointer',
        textAlign: 'center'
    }
};

export const RewardComponent = () => {
    const history = useHistory();
    const { userInfo, publicSettings, businessInfo } = useContext(AuthContext);
    const [loader, setLoader] = useState(true);
    const [showRedemption, setShowRedemption] = useState(false);
    const [satoshi, setSatoshi] = useState({
        points: 0,
        value: 0,
        satoshi: 0,
        allow_redemption: false,
        to_spend: 0
    });

    const { BTC_REDEMPTION_MINIMUM } = publicSettings;

    const currentPath = history.location.pathname;

    useEffect(() => {
        let isMounted = true;
        if (userInfo.account) {
            totalRewards()
                .then(res => {
                    if (!isMounted) return;
                    setSatoshi(res);
                    setLoader(false);
                })
                .catch(() => {
                    if (!isMounted) return;
                    setLoader(false);
                    setSatoshi({
                        points: 0,
                        value: 0,
                        satoshi: 0
                    });
                });
            return () => {
                isMounted = false;
            };
        } else {
            setLoader(false);
            setSatoshi({
                points: 0,
                value: 0
            });
        }
    }, [userInfo?.account]);

    const showRedemModal = () => {
        setShowRedemption(true);
    };

    const handleRedemptionModalClose = () => {
        setShowRedemption(false);
    };

    return (
        <Box
            sx={{
                height: '100%',
                paddingLeft: () => ({
                    xs: 0,
                    lg: '24px'
                })
            }}>
            <Box sx={styles.firstContainer}>
                <Box sx={styles.paystandLogoBroken} component="img" alt="Paystand Logo Reward" src={RewardBackground} />
                <Box
                    component="img"
                    alt="Paystand Logo Reward"
                    src={Trophy}
                    sx={{
                        position: 'absolute',
                        right: '12.5%'
                    }}
                />
                <Typography sx={styles.earnedLabel} component="div">
                    Satoshi Earned
                </Typography>
                <Typography sx={styles.pointsLabel} component="div">
                    {loader ? <CircularProgress size="1em" /> : satoshiFormatter(satoshi.satoshi || 0)}
                </Typography>
                <Typography sx={styles.exchangeLabel} component="div">
                    ~ {btcFormat(satoshi.points)} BTC | {numberFormat(satoshi.value, 2, 2)} USD
                </Typography>
                <Button variant="contained" fullWidth onClick={showRedemModal} disabled={Boolean(businessInfo?.is_frozen)}>
                    Redeem BTC
                </Button>
                {currentPath !== '/rewards' && (
                    <Box
                        sx={{
                            marginTop: '12px'
                        }}>
                        <Typography sx={styles.rewardHistory} onClick={() => history.push(LAYOUT_ROUTES.REWARDS)}>
                            Reward History
                        </Typography>
                    </Box>
                )}
                <RedemptionComponent
                    show={showRedemption}
                    allowRedemption={satoshi.allow_redemption}
                    toSpend={satoshi.to_spend ?? 0}
                    mimumRedemption={BTC_REDEMPTION_MINIMUM.value}
                    onClose={handleRedemptionModalClose}
                />
            </Box>
        </Box>
    );
};

export default RewardComponent;
